import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import Rbac from '../../../components/Rbac';
import admins from './admins';
import roles from './roles';
import mailServer from './mailServer';
import userGroups from './userGroups';
import tradeFeePolicies from './tradeFeePolicies';
import kycPolicies from './kycPolicies';
import notifications from './notifications';
import idBaseDeposit from './idBaseDeposit';
import gateways from './gateways';

const Settings = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      {Rbac.hasPermission('view_admin-users') ?
        <Redirect exact from={`${match.url}/`} to={`${match.url}/admins`}/> :
        Rbac.hasPermission('view_rbac') ?
          <Redirect exact from={`${match.url}/`} to={`${match.url}/roles`}/> :
          Rbac.hasPermission('view_mail-transport') ?
            <Redirect exact from={`${match.url}/`} to={`${match.url}/mailServer`}/> :
            <Redirect exact from={`${match.url}/`} to={`${match.url}/notifications`}/>
      }
      <Route path={`${match.url}/admins`} component={admins}/>
      <Route path={`${match.url}/roles`} component={roles}/>
      <Route path={`${match.url}/mailServer`} component={mailServer}/>
      <Route path={`${match.url}/userGroups`} component={userGroups}/>
      <Route path={`${match.url}/tradeFeePolicies`} component={tradeFeePolicies}/>
      <Route path={`${match.url}/kycPolicies`} component={kycPolicies}/>
      <Route path={`${match.url}/notifications`} component={notifications}/>
      <Route path={`${match.url}/idBaseDeposit`} component={idBaseDeposit}/>
      <Route path={`${match.url}/gateways`} component={gateways}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Settings;
